import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'am-checkbox-list',
  templateUrl: './checkbox-list.component.html',
})
export class CheckboxListComponent implements OnInit, OnChanges {
  @Input()
  public appliedFilters: any;
  @Input()
  public type: string;
  @Input()
  public options: Array<any>;
  @Input()
  public appliedParams: Array<any>;
  @Output()
  public valueChange: EventEmitter<any> = new EventEmitter<any>();

  public showTooltip: boolean;
  public popoverTitle: string;
  public popoverImage: string;
  public allTypeSelected = true;
  public allTypeOption: any;
  constructor() {}

  public ngOnInit() {
    this.shouldShowPopover();
    this.shouldShowPlusLabel();
    this.extractAlloption();
  }

  public ngOnChanges() {
    this.setIsApplied();
  }

  private setIsApplied() {
    this.allTypeSelected = true;
    this.options = this.options.map((option) => {
      const applied = this.appliedFilters.find((appliedFilter) => {
        return !!appliedFilter.values?.find(
          (value) =>
            option.type !== 'NAME' &&
            value.code === option.code &&
            value.description === option.description,
        );
      });
      this.allTypeSelected = (this.allTypeSelected && !applied) || option.code.includes('all_');
      return !applied ? { ...option, isApplied: false } : { ...option, isApplied: true };
    });

    const optionAllFilter = this.options.find(
      (option) => option?.code.includes('all_') && this.allTypeSelected,
    );
    if (!!optionAllFilter) {
      optionAllFilter.isApplied = true;
    }
  }

  public trackByItems(index) {
    return index;
  }

  public valueChangeEmitter(isChecked, type, item) {
    if (item.code.includes('all_')) {
      this.options = this.options.map((option) => {
        if (!option.code.includes('all_') && option.isApplied) {
          this.valueChange.emit({ isChecked: false, type, item: option });
          return { ...option, isApplied: false };
        }
        return option;
      });
    } else {
      item = { ...item, isApplied: isChecked };
      this.options = this.options.map((option) => {
        if (item.code === option.code) {
          return { ...item, isApplied: isChecked };
        }
        return option;
      });
      this.valueChange.emit({ isChecked, type, item });
    }
  }

  public setPopoverInfo(item) {
    setTimeout(() => {
      this.popoverTitle = `RESULT-FILTERS-${item.code}`;
      this.popoverImage =
        item.code === 'PREPAID' ? 'prepaid-info.svg' : 'pay-at-destination-info.svg';
    }, 300);
  }

  public valueCode(code) {
    const value = ['FILTER', 'PREPAID', 'PAY_AT_DESTINATION'].includes(code);
    return value;
  }

  public orderPaymentOptions() {
    this.options = [this.options[0], this.options[2], this.options[1]];
  }

  public shouldShowPopover() {
    if (this.type === 'PAYMENT_METHOD') {
      if (this.options.length === 3) {
        this.orderPaymentOptions();
      }
      this.showTooltip = true;
    }
  }

  public shouldShowPlusLabel() {
    this.appliedFilters?.map((filter) => {
      if (
        (filter?.type === this.type ||
          this.options.some((option) => option?.type === filter?.type)) &&
        filter.combination_type === 'OR'
      ) {
        this.options = this.options.map((option) => {
          const isApplied = filter.values.some((value) => value.code === option.code);
          const isSameType = option?.type ? filter?.type === option?.type : true;
          return !isApplied && isSameType ? { ...option, showPlus: true } : { ...option };
        });
      }
    });
  }

  public extractAlloption() {
    if (this.options !== undefined) {
      const option = this.options.filter((item) => {
        return item?.description.includes('all');
      })[0];

      if (option !== undefined) {
        this.allTypeOption = option;
        const index = this.options.indexOf(option);
        this.options.splice(index, 1);
      }
    }
  }
}
